export const styles = {
  appsCard: {
    rowGap: 24,
  },
};
